(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bonanza-browsing-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bonanza-collection-browser')) {
  customElements.define('bonanza-collection-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.events = new AbortController();
      this.grid = this.querySelector('[data-bonanza-products]');
      this.nextLink = this.querySelector('[data-bonanza-next]');
      this.sentinel = this.querySelector('[data-bonanza-sentinel]');
      this.status = this.querySelector('[data-bonanza-status]');
      this.empty = this.querySelector('[data-bonanza-empty]');
      this.backTop = this.querySelector('[data-bonanza-back-top]');
      this.url = new URL(location.href);
      this.inStock = this.url.searchParams.get('filter.v.availability') === '1';
      this.nextURL = this.nextLink.hidden ? null : this.nextLink.href;
      this.loadText = this.nextLink.textContent;
      this.seen = new Set();
      this.visited = new Set();
      this.loaded = 0;
      this.busy = false;
      this.failed = false;
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-bonanza-stock]').forEach(link => {
        const url = new URL(this.url);
        url.searchParams.delete('page');
        url.searchParams.delete('filter.v.availability');
        const selected = link.dataset.bonanzaStock === 'in-stock';
        if (selected) url.searchParams.set('filter.v.availability', '1');
        link.href = url.href;
        if (selected === this.inStock) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      this.querySelectorAll('[data-bonanza-category]').forEach(link => {
        const url = new URL(link.href);
        if (this.inStock) url.searchParams.set('filter.v.availability', '1');
        const sort = this.url.searchParams.get('sort_by');
        const view = this.url.searchParams.get('view');
        if (sort) url.searchParams.set('sort_by', sort);
        if (view) url.searchParams.set('view', view);
        link.href = url.href;
      });
      this.querySelectorAll('[data-bonanza-view]').forEach(link => {
        const url = new URL(this.url);
        url.searchParams.delete('page');
        url.searchParams.set('view', link.dataset.bonanzaView);
        link.href = url.href;
        if (link.dataset.bonanzaView === (this.url.searchParams.get('view') || 'grid')) link.setAttribute('aria-current', 'true');
      });
      this.querySelector('[data-bonanza-sort]')?.addEventListener('change', event => {
        const url = new URL(location.href);
        url.searchParams.delete('page');
        url.searchParams.set('sort_by', event.target.value);
        location.assign(url.href);
      }, options);
      this.grid.querySelectorAll('[data-bonanza-card]').forEach(card => {
        this.seen.add(card.dataset.productId);
        if (this.inStock && card.dataset.available !== 'true') card.hidden = true;
        else this.loaded++;
      });
      this.nextLink.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.loadMore(true);
      }, options);
      this.backTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        document.querySelector('header a')?.focus({ preventScroll: true });
      }, options);
      this.scrollFrame = 0;
      window.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.backTop.hidden = window.scrollY < 450;
          this.scrollFrame = 0;
        });
      }, { ...options, passive: true });
      this.backTop.hidden = window.scrollY < 450;
      this.mobile = matchMedia('(max-width: 767px)');
      this.setSidebar = () => { const panel = this.querySelector('[data-bonanza-sidebar]'); if (panel) panel.open = !this.mobile.matches; };
      this.setSidebar();
      this.mobile.addEventListener('change', this.setSidebar, options);
      if ('IntersectionObserver' in window && this.dataset.autoload !== 'false') {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.failed) this.loadMore(false);
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this.sentinel);
      }
      this.updateStatus();
    }
    updateStatus() {
      this.nextLink.hidden = !this.nextURL;
      this.nextLink.removeAttribute('aria-disabled');
      this.nextLink.textContent = this.loadText;
      this.empty.hidden = this.loaded > 0 || Boolean(this.nextURL);
      if (!this.loaded && !this.nextURL && this.inStock) this.empty.textContent = this.dataset.noStock;
      const shown = this.dataset.loaded.replace('[count]', this.loaded);
      this.status.textContent = this.nextURL ? shown : (this.loaded ? shown + ' · ' + this.dataset.complete : '');
      if (this.nextURL) this.nextLink.href = this.nextURL;
    }
    async loadMore(manual) {
      if (this.busy || !this.nextURL || !this.isConnected) return;
      this.busy = true;
      this.failed = false;
      this.grid.setAttribute('aria-busy', 'true');
      this.nextLink.setAttribute('aria-disabled', 'true');
      this.nextLink.textContent = this.dataset.loading;
      this.status.textContent = this.dataset.loading;
      let firstNewLink = null;
      let added = 0;
      let pages = 0;
      try {
        do {
          const pageURL = new URL(this.nextURL, location.href);
          if (pageURL.origin !== location.origin || this.visited.has(pageURL.href)) throw new Error('Invalid next page');
          const fetchURL = new URL(pageURL);
          fetchURL.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(fetchURL.href, { credentials: 'same-origin', signal: this.events.signal });
          if (!response.ok) throw new Error('Collection page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = doc.querySelector('bonanza-collection-browser');
          if (!section || !section.querySelector('[data-bonanza-products]')) throw new Error('Collection markup missing');
          const fragment = document.createDocumentFragment();
          section.querySelectorAll('[data-bonanza-products] > [data-bonanza-card]').forEach(card => {
            const id = card.dataset.productId;
            if (!id || this.seen.has(id)) return;
            this.seen.add(id);
            if (this.inStock && card.dataset.available !== 'true') return;
            firstNewLink ||= card.querySelector('a');
            fragment.append(card);
            added++;
            this.loaded++;
          });
          this.grid.append(fragment);
          this.visited.add(pageURL.href);
          const next = section.querySelector('[data-bonanza-next]');
          const following = next && !next.hidden && next.getAttribute('href') ? new URL(next.getAttribute('href'), pageURL) : null;
          if (following) {
            following.searchParams.delete('section_id');
            following.searchParams.delete('sections');
          }
          this.nextURL = following?.href || null;
          pages++;
        } while (!added && this.nextURL && pages < 5);
        this.updateStatus();
        if (manual && firstNewLink) firstNewLink.focus({ preventScroll: false });
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.failed = true;
        this.status.textContent = this.dataset.error;
        this.nextLink.textContent = this.dataset.retry;
        this.nextLink.removeAttribute('aria-disabled');
      } finally {
        this.busy = false;
        this.grid.removeAttribute('aria-busy');
        if (!this.failed && this.nextURL && this.observer) {
          this.observer.unobserve(this.sentinel);
          this.observer.observe(this.sentinel);
        }
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bonanza-commerce-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bonanza-quantity')) {
    customElements.define('bonanza-quantity', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-quantity-change]');
          const input = this.querySelector('input');
          if (!button || !input || input.disabled) return;
          const min = Number(input.min) || 1;
          const max = input.max ? Number(input.max) : Infinity;
          const step = Number(input.step) || 1;
          const current = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
          input.value = String(Math.min(max, Math.max(min, current + Number(button.dataset.quantityChange) * step)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.bonanza-mega[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.bonanza-mega[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.bonanza-mega[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bonanza-design-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bonanza-design-selector')) {
    customElements.define('bonanza-design-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.select = this.querySelector('[data-design-select]');
        this.scope = this.closest('[data-section-id]') || this.parentElement;
        this.form = this.closest('form');
        this.select.addEventListener('change', () => this.sync(true), { signal });
        this.scope.addEventListener('click', event => {
          const thumb = event.target.closest('.product-photo-thumb[data-image-id]');
          if (!thumb) return;
          const option = Array.from(this.select.options).find(item => item.dataset.imageId === thumb.dataset.imageId);
          if (option) {
            this.select.value = option.value;
            this.sync(false);
          }
        }, { signal });
        this.form.addEventListener('submit', event => {
          if (!this.select.checkValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.select.reportValidity();
          }
        }, { capture: true, signal });
        if (this.select.value) this.sync(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      sync(showGallery) {
        const option = this.select.selectedOptions[0];
        if (!option?.value) return;
        this.querySelector('[data-design-photo]').value = option.dataset.imageUrl;
        const preview = this.querySelector('[data-design-preview]');
        const image = preview.querySelector('img');
        image.removeAttribute('srcset');
        image.src = option.dataset.imageUrl;
        image.alt = option.dataset.designLabel;
        preview.hidden = false;
        this.querySelector('[data-design-output]').textContent = option.dataset.designLabel;
        if (showGallery) {
          const thumb = this.scope.querySelector('.product-photo-thumb[data-image-id="' + option.dataset.imageId + '"]');
          thumb?.click();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
